import Dexie from 'dexie';
import { CommuteFltData } from '../models/CommuteFltData';
import { FlightDataMaster } from '../models/FlightDataMaster';
import { LatestNews } from '../models/LatestNews';
import { TblBidDataDisplay } from '../models/TblBidDataDisplay';
import { TblColumnDefinitions } from '../models/TblColumnDefinitions';
import { TblFAList } from '../models/TblFAList';
import { TblINI } from '../models/TblINI';
import { TblQuickSet } from '../models/TblQuickSet';
import { TblStateQuickSetVersionInfo } from '../models/TblStateQuickSetVersionInfo';
import { TblUserBidReceipt } from '../models/TblUserBidReceipt';
import { TblUserData } from '../models/TblUserData';
import { TblUsers } from '../models/TblUsers';
import { tbl_BidFileName } from '../models/tbl_BidFileName';
import { tbl_WbidFiles } from '../models/tbl_WbidFiles';
import { StateFiles } from '../models/WBidStateCollection';
import { bidEditorString } from '../models/BidEditorString';

export class WbidAppDB extends Dexie {
  UserData: Dexie.Table<TblUserData, string>;
  BidDataDisplay: Dexie.Table<TblBidDataDisplay, number>;
  _Users: Dexie.Table<TblUsers, number>;
  _INI: Dexie.Table<TblINI, number>;
  ColumnDefinitions: Dexie.Table<TblColumnDefinitions, string>;
  WbidFiles: Dexie.Table<tbl_WbidFiles, string>;
  BidFileNames: Dexie.Table<tbl_BidFileName, number>;
  FAListData: Dexie.Table<TblFAList, number>;
  LatestNews: Dexie.Table<LatestNews, string>;
  FlightDataMaster: Dexie.Table<FlightDataMaster, number>;
  StateFiles: Dexie.Table<StateFiles, number>;
  StateQuickSetVersionInfo: Dexie.Table<TblStateQuickSetVersionInfo, string>;
  QuickSet: Dexie.Table<TblQuickSet, string>;
  UserBidReceipt: Dexie.Table<TblUserBidReceipt, number>;
  CommuteFltChange: Dexie.Table<CommuteFltData, string>;
  bidEditorChoice: Dexie.Table<bidEditorString, string>;
  constructor() {
    super('WbidMaxDB');
    const db = this;

    db.version(1).stores({
      UserData:
        '++id,empId,IsAuthorized,AuthRequestId,Message,Type,ExpirationDate,CBExpirationDate,WBExpirationDate,IsFree,IsYearlySubscribed,IsMonthlySubscribed,TopSubscriptionLine,SecondSubscriptionLine,ThirdSubscriptionLine,EmailId',
    });
    db.version(2).stores({
      BidDataDisplay:
        '++id, domicile, position, round, month, year, lines, trips, vacationLines, vacationEomLines, eomLines,milLines, state, fileid, size, modified, created, EmpNum,BidPeriodStartDate,BidPeriodEndDate,isEBGUser',
      _INI: '++id,userId, compressedname, fileid,size,modified,created',
      _Users: '++id,userid,modified',
      ColumnDefinitions: '++id, version, columnDefinitions',
    });
    db.version(3).stores({
      WbidFiles: '++id, fileName, fileContent',
    });
    db.version(4).stores({
      BidFileNames: '++id, empId, fieldId, bidFiles',
    });
    db.version(5).stores({
      FAListData: '++id, employeeId, faList',
    });
    db.version(6).stores({
      LatestNews: '++id, latestNewsContent',
    });
    db.version(7).stores({
      FlightDataMaster: '++id, flightDataCompressedStr,flightdataVersionNumber',
    });
    db.version(8).stores({
      StateFiles:
        '++id, stateKey, employeeId, bidId, CompanyVA, DataSource, DefaultName, FVVacation, IsModified, SeniorityListItem, StateList, StateUpdatedTime, SyncVersion, Vacation, Version, FileName',
    });
    db.version(9).stores({
      StateQuickSetVersionInfo:
        '++id, empId, quickSetVersion, stateVersion, quickSetLastUpdatedTime, stateLastUpdatedTime, quickSetLastUpdatedDate, stateLastUpdatedDate, isStateModified, isQuickSetModified,  fileid',
    });
    db.version(10).stores({
      QuickSet: '++id,empId,quickSetData',
    });
    db.version(11).stores({
      UserBidReceipt: '++id, employeeId, bidReceipt',
    });
    db.version(12).stores({
      FlightDataMaster:
        '++id, flightDataCompressedStr,flightDataName,bidType,flightdataVersionNumber',
    });
    db.version(13).stores({
      CommuteFltChange: '++id, fileContent,fileName',
    });
    db.version(14).stores({
      bidEditorChoice: '++id, fileContent,fileName',
    });
    db.open();
    db.UserData.mapToClass(TblUserData);
    db.BidDataDisplay.mapToClass(TblBidDataDisplay);
    db._INI.mapToClass(TblINI);
    db._Users.mapToClass(TblUsers);
    db.ColumnDefinitions.mapToClass(TblColumnDefinitions);
    db.WbidFiles.mapToClass(tbl_WbidFiles);
    db.BidFileNames.mapToClass(tbl_BidFileName);
    db.FAListData.mapToClass(TblFAList);
    db.LatestNews.mapToClass(LatestNews);
    db.FlightDataMaster.mapToClass(FlightDataMaster);
    db.StateFiles.mapToClass(StateFiles);
    db.StateQuickSetVersionInfo.mapToClass(TblStateQuickSetVersionInfo);
    db.QuickSet.mapToClass(TblQuickSet);
    db.UserBidReceipt.mapToClass(TblUserBidReceipt);
    db.CommuteFltChange.mapToClass(CommuteFltData);
    db.bidEditorChoice.mapToClass(bidEditorString);
  }
}

export const db = new WbidAppDB();
